(function (angular) {
    'use strict';

    angular.module('profiles')

        .config(['$stateProvider', function ($stateProvider) {
            
            function handleError($q, error) {
                var deferred = $q.defer();

                if (error.status < 500) { 
                    deferred.resolve(error); 
                } else { 
                    deferred.reject(error); 
                }

                return deferred.promise;
            }

            $stateProvider.defaultSpecificState = function (params) {
                //name, url, template, controller, resolve
                if (!params.resolve) {
                    params.resolve = {};
                }
                return this.state(params.name, {
                    url: params.url,
                    templateUrl: params.template,
                    template: params.inlineTemplate,
                    controller: params.controller,
                    resolve: params.resolve,
                    authenticate: true,
                    params: params.params
                });
            };

            $stateProvider
            .state('main.apiSpace.profiles', {
                url: '/profiles',
                template: '<ui-view/>',
                authenticate: true
            })
            .defaultSpecificState({
                name: 'main.apiSpace.profiles.search',
                url: '/search/{criteria}',
                template: 'components/toolkit/profiles/templates/profilesView.html',
                controller: 'profilesCtrl',
                params: {
                    sorting: null,
                    pickedCriteria: null
                },
                resolve: {
                    profileSchema: ['$q', 'profilesService', '$stateParams', 'profileHelper', function ($q, profilesService, $stateParams, profileHelper) {
                        if (profileHelper.getSchema().length) {
                            return profileHelper.getSchema();
                        }
                        else {
                            return profilesService.getProfileSchema($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return profileHelper.setSchema(result);
                                }).catch(function (error) {
                                    return handleError($q, error);
                                });
                        }
                    }]
                }

            })
            .defaultSpecificState({
                name: 'main.apiSpace.profiles.audience',
                url: '/audience',
                template: 'components/toolkit/profiles/templates/audiencesView.html',
                controller: 'audienceCtrl',
                resolve: {
                    audiences: ['$q', 'audiencesService', '$stateParams', function ($q, audiencesService, $stateParams) {
                        return audiencesService.getAudiences($stateParams.pickedApiSpaceId)
                            .then(function (result) {
                                return result;
                            }).catch(function (error) {
                                return handleError($q, error);
                            });
                    }],
                    profileSchema: ['$q', 'profilesService', '$stateParams', 'profileHelper', function ($q, profilesService, $stateParams, profileHelper) {
                        if (profileHelper.getSchema().length) {
                            return profileHelper.getSchema();
                        }
                        else {
                            return profilesService.getProfileSchema($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return profileHelper.setSchema(result);
                                }).catch(function (error) {
                                    return handleError($q, error);
                                });
                        }
                    }]

                }

            })
            .defaultSpecificState({
                name: 'main.apiSpace.profiles.history',
                url: '/history',
                template: 'components/toolkit/profiles/templates/historyView.html',
                controller: 'profileHistoryCtrl',
                resolve: {
                    profilesHistory: ['$q', 'profilesService', '$stateParams', function ($q, profilesService, $stateParams) {
                        return profilesService.getHistory($stateParams.pickedApiSpaceId)
                            .then(function (result) {
                                return result;
                            }).catch(function (error) {
                                return handleError($q, error);
                            });
                    }]
                }

            })
            .defaultSpecificState({
                name: 'main.apiSpace.profiles.template',
                url: '/template',
                template: 'components/toolkit/profiles/templates/templateView.html',
                controller: 'profileTemplateCtrl',
                resolve: {
                    template: ['$q', 'profileTemplateService', '$stateParams', function ($q, profileTemplateService, $stateParams) {
                        return profileTemplateService.getProfileTemplate($stateParams.pickedApiSpaceId)
                            .then(function (result) {
                                return result;
                            }).catch(function (error) {
                                return handleError($q, error);
                            });
                    }]
                }

            })
            .defaultSpecificState({
                name: 'main.apiSpace.profile',
                url: '/profile/{profileId}',
                template: 'components/toolkit/profiles/templates/profileView.html',
                controller: 'ProfileCtrl',
                params: {
                    criteria: null,
                    sorting: null,
                    pickedCriteria: null
                },
                resolve: {
                    profileSchema: ['$q', 'profilesService', '$stateParams', 'profileHelper', function ($q, profilesService, $stateParams, profileHelper) {
                        if (profileHelper.getSchema().length) {
                            return profileHelper.getSchema();
                        }
                        else {
                            return profilesService.getProfileSchema($stateParams.pickedApiSpaceId)
                                .then(function (result) {
                                    return profileHelper.setSchema(result);
                                }).catch(function (error) {
                                    return handleError($q, error);
                                });
                        }
                    }],
                    profileDetailsSet: ['$q', 'profilesService', '$stateParams', 'profileTemplateService', 'profileHelper', function ($q, profilesService, $stateParams, profileTemplateService, profileHelper) {
                        return profileTemplateService.getProfileTemplate($stateParams.pickedApiSpaceId)
                            .then(function (profileTemplate) {
                                return profilesService.getProfile($stateParams.pickedApiSpaceId, $stateParams.profileId)
                                    .then(function (result) {
                                        profileHelper.buildProfile(result, profileTemplate);
                                        return result;
                                    }).catch(function (error) {
                                        return handleError($q, error);
                                    });
                            }).catch(function (error) {
                                return handleError($q, error);
                            });
                    }],
                    possibleChannels: ['$q', 'customChannelService', '$stateParams', function($q, customChannelService, $stateParams){
                        return customChannelService.getPossibleChannels()
                        .then(function (result) {
                            return result;
                        }).catch(function (error) {
                            return handleError($q, error);
                        });
                    }],
                    customChannels: ['$q', 'customChannelService', '$stateParams', function($q, customChannelService, $stateParams){
                        return customChannelService.getCustomChannels($stateParams.pickedApiSpaceId)
                        .then(function (result) {
                            return result;
                        }).catch(function (error) {
                            return handleError($q, error);
                        });
                    }]
                }
            })
            .defaultSpecificState({
                name: 'main.apiSpace.profile.properties',
                url: '/properties',
                template: 'components/toolkit/profiles/templates/properties.html',
                controller: 'PropertiesCtrl',
            })
            .defaultSpecificState({
                name: 'main.apiSpace.profile.devices',
                url: '/devices',
                template: 'components/toolkit/profiles/templates/devices.html',
                controller: 'DevicesCtrl'
            })
            .defaultSpecificState({
                name: 'main.apiSpace.profile.history',
                url: '/history',
                template: 'components/toolkit/profiles/templates/messageHistory.html',
                controller: 'MessageHistoryCtrl'
            });

        }]);

})(window.angular);